/**
 * Live Probability page (live/explore/PROBABILITY).
 *
 * Thin wrapper: renders the shared project-wide ProbabilityHistory page in `live` mode — it reads the live session
 * parquet for the active playback window (no datetime-range picker; a Refresh button reloads up to the live edge).
 * See reports/gp50/project/all/explore/ProbabilityHistory.tsx for the `live` behavior.
 */
import ProbabilityHistoryPage from "../../project/all/explore/ProbabilityHistory";

export default function LiveProbabilityPage(props: Record<string, unknown>) {
  return <ProbabilityHistoryPage {...props} live={true} />;
}
